import styled from '@emotion/styled';

import {
  Accordion,
  AccordionCell,
} from '../../../components/Accordion/Accordion';
import useIntersectionAnimate from '../../../hooks/useIntersectionObserver';
import { FrequentlyAskedQuestionsData } from './FrequentlyAskedQuestionsData';

function FrequentlyAskedQuestions() {
  useIntersectionAnimate('.intersection-animate', 'animate', {
    threshold: 0.7,
  });

  return (
    <Container className='intersection-animate'>
      <Header>Frequently Asked Questions (FAQs)</Header>
      <Accordion>
        {FrequentlyAskedQuestionsData.map((data, index) => (
          <AccordionCell key={index} title={data.title}>
            {data.content}
          </AccordionCell>
        ))}
      </Accordion>
    </Container>
  );
}

export default FrequentlyAskedQuestions;

const Container = styled.div`
  margin: 0 -5.4375rem;
  margin-bottom: -16px;
  padding: 83.17px 5.4375rem;
  display: flex;
  flex-direction: column;
  gap: 47px;
  background-color: ${({ theme }) => theme.palette.offWhite};

  @media (max-width: 884px) {
    margin: 0 -24px;
    padding: 1rem 24px;
    padding-bottom: 55px;
  }

  &.animate {
    --ytrans: 100%;

    & > div {
      animation-duration: 0.5s;
      animation-name: move;
      animation-fill-mode: backwards;
    }

    & > div:first-of-type {
      animation-delay: 0.2s;
      /* background-color: red; */
    }

    & > div:last-of-type {
      --ytrans: 20%;
      animation-delay: 0.4s;
      /* background-color: yellow; */
    }

    @keyframes move {
      from {
        transform: translateY(var(--ytrans));
      }
      to {
        transform: 0;
      }
    }
  }
`;

const Header = styled.div`
  font-weight: 700;
  font-size: 44px;
  line-height: 44px;

  @media (max-width: 884px) {
    font-weight: 700;
    font-size: 36px;
    line-height: 46.8px;
  }
`;
